import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Products from "@/components/site/Products";
import WhatWeBuy from "@/components/site/WhatWeBuy";
import Facility from "@/components/site/Facility";
import Manifesto from "@/components/site/Manifesto";
import Vision from "@/components/site/Vision";
import Services from "@/components/site/Services";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Navbar />
      <Hero />
      <Ticker />
      <Products />
      <WhatWeBuy />
      <Facility />
      <Services />
      <Manifesto />
      <Vision />
      <QuoteForm />
      <Footer />
    </main>
  );
}
